import { IEmailModel } from "../../../models"

export interface IEmailModelState {
    list: IEmailModel[];
    emailModelTemplateVariables: string[];
    emailEngineVariableKeys: string[];
}